import {avater} from "../../utils/Constants";
import {imageBaseUrl} from "../../redux/apis/api";


const mobileNumberHide = (student_msisdn) => {
    return student_msisdn.replace(student_msisdn.substring(6, student_msisdn.length - 3), '***')
};

export default mobileNumberHide;